<template>
  <PageMain class="app-container waybill-query-page">
    <div class=" mt-20 bg-w pl-80 pr-80 pb-100">
      <div class="fs-24 fs-b f-c-b  pt-40 pb-40 t-center">运费查询</div>
      <div class="flex a-center">
        <div>

          <div class="flex a-center "><div class="mr-10">寄件地址：</div><div><Addr :addr-detail="false" :result.sync="saddr" class="w-180" /></div></div>
          <div class="flex a-center mt-20"><div class="mr-10">收件地址：</div><div><Addr :addr-detail="false" :result.sync="raddr" class="w-180" /></div></div>
          <div class="flex a-center mt-20"><div class="mr-10">预估重量：</div><div> <a-input v-model="weight" class="w-180" :default-value="0" type="number" suffix="KG" /></div></div>
          <div class="flex a-center mt-20">
            <div class="mr-10">快递公司：</div>
            <div>
              <a-select v-model="shipperCode" class="w-180" placeholder="请输入快递公司">
                <a-select-option v-for="(i,index) in companys" :key="index" :value="i.shipperCode">{{ i.shipperName }}</a-select-option>
              </a-select>
            </div>
          </div>
          <div class="mt-20"><a-button type="primary" :loading="loading" @click="search">查询</a-button></div>
        </div>
        <div class="flex1">
          <div class="h-line h-220  m-center" />
        </div>
        <div class="mr-20">
          <div class="mb-20 fs-24">市场参考价格</div>
          <div class="item bb-none">预估重量：<span class="fs-b fs-32 f-c-b1">{{ weight }}</span>kg</div>
          <div class="item ">预估运费：<span class="fs-b fs-32 f-c-b1">{{ estimateMarketPrice }}</span>元</div>
          <!-- <div><a-button type="primary" class="w-300" @click="$router.replace('/main/send')">在线寄件</a-button></div> -->
        </div>
        <div>
          <div class="mb-20 fs-24">企业寄件预估价格</div>
          <div class="item bb-none">预估重量：<span class="fs-b fs-32 f-c-b1">{{ weight }}</span>kg</div>
          <div class="item">预估运费：<span class="fs-b fs-32 f-c-b1">{{ price }}</span>元</div>
          <!-- <div><a-button type="primary" class="w-300" @click="$router.replace('/main/send')">在线寄件</a-button></div> -->
        </div>
      </div>
    </div>
  </PageMain>
</template>
<script>

/**
 * 如何使用vue
 * 这里做最基本的用法演示，详细请看vue的官网
 * https://cn.vuejs.org/v2/guide/
 */
import Addr from '@/components/addr.vue'
import icoMap from '@/common/icoMap'

export default {
  name: 'WaybillQuery',
  components: {
    Addr
  },
  data() {
    // data函数返回的对象是具有双向绑定的数据，更新data里面的数据，可以触发ui的变化
    return {
      icoMap,
      saddr: null,
      raddr: null,
      sIndex: '',
      weight: 1,
      shipperCode: '',
      companys: [],
      price: 0,
      estimateMarketPrice: 0,
      loading: false
    }
  },
  async created() {
    // 组件创建时，这个函数就会被触发
    const res = await this.$http(this.$api.logisticsGetList)
    this.companys = res || []
  },
  methods: {
    // methods这个对象，存放的是template标签里面使用的方法
    async search() {
      if (!this.saddr) {
        this.$message.warning('请选择寄件所在省市区')
        return
      }
      if (!this.raddr) {
        this.$message.warning('请选择收件所在省市区')
        return
      }
      if (!this.weight) {
        this.$message.warning('请输入预估重量')
        return
      }
      if (!this.shipperCode) {
        this.$message.warning('请选择快递公司')
        return
      }
      try {
        this.loading = true
        const res = await this.$http(this.$api.logisticsGetEstimatePrice, {
          'fromProvice': this.saddr.provinceName,
          'fromCity': this.saddr.cityName,
          toCity: this.raddr.cityName,
          'shipperCode': this.shipperCode,
          'toProvice': this.raddr.provinceName,
          'weight': this.weight
        })
        this.loading = false
        if (res) {
          this.price = res.estimatePrice
          this.estimateMarketPrice = res.estimateMarketPrice
        }
      } catch (error) {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" >
.waybill-query-page {

  .bg-grey{
    background: rgba(245, 247, 250, 1);
  }
  .h-line{
    margin-top: 2px;
    margin-bottom: 2px;
    width: 1px;
    height: 100%;
    background: rgba(0, 0, 0, 0.15);
  }
  .bg-blue1{
    background: rgba(240, 245, 255, 1);
  }
  .item{
    width: 300px;
    height: 80px;
    border:1px solid rgba(0, 0, 0, 0.15);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .bb-none{
    border-bottom: none;;
  }

}
</style>
